module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-70x70.ee381f051c1ae5e0cc53be4951a4c42a.png";